import { render } from "./TreeDataAndLazyMode.vue?vue&type=template&id=34bc36d4"
import script from "./TreeDataAndLazyMode.vue?vue&type=script&lang=ts"
export * from "./TreeDataAndLazyMode.vue?vue&type=script&lang=ts"
script.render = render

export default script